/*
 * colors.js 12.01.18
 *
 * (c) 2018 ergovia GmbH
 */

/**
 * JS-File für alle Farben die App-übergreifend angewendet werden sollen.
 */

export const MAIN_COLOR = '#03a9f4';
export const TEXT_COLOR_INVERSE = '#FFFFFF';

export const COLOR_CODE_POSITIVE = '#6bc56a';
export const COLOR_CODE_NEUTRAL = '#3f3f4f';
export const COLOR_CODE_WARNING = '#FFC213';
export const COLOR_CODE_NEGATIVE = '#E84549';



// WEBPACK FOOTER //
// ./src/de/ergovia/styles/colors.js